export default "__VITE_ASSET__CEf3OMYm__"